import React, { useContext, useState, useLayoutEffect } from "react";
import { isEqual } from "lodash";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { distinctUntilChanged, pluck, filter } from "rxjs/operators";
import { Subject } from "rxjs";

import { TableContext } from "./TableContext";
import { decodeSorting, encodeSorting, nextSort } from "./utils";
import {
  TableActionTypes,
  ITableState,
  TColumnSorting,
  IColumn
} from "./interfaces";

export const Column: React.FC<IColumn> = props => {
  const { dispatch, subscribe } = useContext(TableContext);
  const [sorting, setSorting] = useState<TColumnSorting>({
    active: false,
    direction: "desc"
  });
  const { label, id } = props;

  useLayoutEffect(() => {
    const tableStateObserver$ = new Subject<ITableState>();

    tableStateObserver$
      .pipe(
        pluck("sorting"),
        filter(sorting => !!sorting),
        distinctUntilChanged((next, prev) => isEqual(prev, next))
      )
      .subscribe(sorting => {
        if (!sorting || id !== sorting.id) {
          setSorting({
            active: false,
            direction: "desc"
          });
        } else {
          setSorting(decodeSorting(sorting.sortDirection));
        }
      });

    const subscription = subscribe(tableStateObserver$);

    return () => {
      tableStateObserver$.complete();
      subscription.unsubscribe();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <TableCell key={id} sortDirection={encodeSorting(sorting)}>
      <Tooltip title="Sort" placement={"bottom-start"} enterDelay={300}>
        <TableSortLabel
          active={sorting.active}
          direction={sorting.direction}
          onClick={() => {
            dispatch({
              name: id,
              type: TableActionTypes.sorting,
              payload: nextSort(encodeSorting(sorting))
            });
          }}
        >
          {label}
        </TableSortLabel>
      </Tooltip>
    </TableCell>
  );
};
